angular.module("rental")
    .constant("RentalResourceConst", {
        eventUpdate: "rental-resource.update",
        eventDelete: "rental-resource.deleted",
        RoleModule: "ROLE_RENTAL_MODULE",
        RoleResourceRead: "ROLE_RENTAL_MODULE",
        RoleResourceWrite: "ROLE_RENTAL_RESOURCE_WRITE"
    })
    .factory("RentalResource", function ($resource) {
        return $resource("/crm/api/rental-resource/:id", {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/rental-resource/table'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/rental-resource/autocomplete'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/rental-resource/table-statistics'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
    })
    .service('RentalResourceService', function (modals, $rootScope, RentalResource, RentalResourceConst) {
        this.add = params => {
            let entity = {
                id: null,
                status: 'ACTIVE',
                activity: []
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            modals.open('app/rental/resource/edit-modal.html', 'RentalResourceEditController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.open = id => {
            RentalResource.get({id: id}).$promise.then(entity => this.show(entity))
        }
        this.show = entity => {
            modals.open('app/rental/resource/show-modal.html', 'RentalResourceShowController', angular.copy(entity), {size: 'lg'}, "$ctrl")
        }
        this.delete = entity => {
            return modals.confirmDelete("wybrany rekord", () => RentalResource.delete({id: entity.id}).$promise.then(() => $rootScope.$broadcast(RentalResourceConst.eventDelete)));
        }
    })
    .config(function ($stateProvider, RentalResourceConst) {
        $stateProvider.state('rentalResourceList', {
            parent: 'app',
            url: '/rental-resource?{page:int}&{size:int}&{sort:string}&{search:string}&status&type&availability&activity&rentalsAtDate&indexation&{agreementSearch:string}',
            data: {
                authorities: [RentalResourceConst.RoleResourceRead]
            },
            params: {
                status: {array: true, value: [], squash: false},
                type: {array: true, type: "int", value: [], squash: false},
            },
            views: {
                'content@': 'rentalResourceList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (RentalResource, $stateParams) => RentalResource.table(angular.copy($stateParams)).$promise,
                statistics: (RentalResource, $stateParams) => RentalResource.tableStatistics(angular.copy($stateParams)).$promise,
            }
        })
        $stateProvider.state('rentalResourceShow', {
            parent: 'app',
            url: '/rental-resource/{id}',
            data: {
                authorities: [RentalResourceConst.RoleResourceRead]
            },
            views: {
                'content@': 'rentalResourceShow'
            },
            resolve: {
                item: (RentalResource, $stateParams) => RentalResource.get({id: $stateParams.id}).$promise
            }
        });
    })
    .run(function (NavbarLeftMenu, RentalAgreementConst) {
        NavbarLeftMenu.add({
            authorities: RentalAgreementConst.RoleModule,
            path: "/rental-resource?activity=ACTIVE",
            ico: "fa fa-fw fa-file-text-o",
            name: 'rental.menu',
            order: 84
        })
    })
